<template>
  <section class="guides-skeleton">
    <div
      v-for="i in 5"
      :key="i"
      class="guide-skeleton"
    >
      <div class="guide-skeleton__left">
        <SkeletonItem class="avatar" />
        <div class="info">
          <SkeletonItem class="name" />
          <div class="meta">
            <SkeletonItem class="meta-line left" />
            <SkeletonItem class="meta-line middle" />
            <SkeletonItem class="meta-line right" />
          </div>
          <SkeletonItem class="desc-line top" />
          <SkeletonItem class="desc-line medium" />
          <SkeletonItem class="desc-line short" />
        </div>
      </div>
      <div class="guide-skeleton__right">
        <SkeletonItem class="button" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  // Widgets

  // Features

  // Entities

  // Shared

  // External and shared packages
  import { SkeletonItem } from '@experience/core-skeleton-lib';
</script>

<style scoped lang="scss">
  .guides-skeleton {
    margin-top: 24px;
  }

  .guide-skeleton {
    display: flex;
    gap: 24px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
  }

  .guide-skeleton__left {
    display: flex;
    flex: 1;
  }

  .avatar {
    flex-shrink: 0;
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }

  .info {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 8px;
    max-width: 700px;
    margin-left: 22px;
  }

  .name {
    width: 120px;
    height: 24px;
    border-radius: 8px;
  }

  .meta {
    display: flex;
    gap: 12px;
  }

  .meta-line {
    height: 16px;
    border-radius: 8px;

    &.left {
      width: 23%;
    }

    &.middle {
      width: 18.92%;
    }

    &.right {
      width: 28.07%;
    }
  }

  .desc-line {
    height: 14px;
    border-radius: 8px;
  }

  .desc-line.top {
    width: 100%;
  }

  .desc-line.medium {
    width: 100%;
  }

  .desc-line.short {
    width: 85%;
  }

  .guide-skeleton__right {
    display: flex;
    justify-content: center;
    width: 200px;

    .button {
      width: 200px;
      height: 40px;
      border-radius: 8px;
    }
  }
</style>
